import src from "IMAGE";
export default { src, width: 1524, height: 438, blurWidth: 0, blurHeight: 0};
